export const undoLastEdit = (
  e,
  setToggleClearSF,
  positionEdits,
  undoList,
  setUSposition,
  setUSpositionData,
  setShowcalculator,
  setUndoFocusFlag,
  loadedPosition,
  loadedPositionData,
  setEditID,
  setPaymentterm,
  setPaymenttermData,
  paymentterm,
  paymenttermData,
  loadedPayterm,
  loadedPaytermData
) => {
  // Executes when pressing Ctrl+z. Behavior attached via AddEventListener
  e.preventDefault(); // Prevent the default browser undo behavior
  // Get the currently focused input field
  const activeInput = document.activeElement;
  // Check if the focused input field has a value then esc the input and exit.
  if (activeInput && activeInput.value) {
    setToggleClearSF((prev) => !prev);
  }
  const numtypes = ["decimal", "percent", "currency", "integer", "radio", "text"];
  let lookedUpEdits = [];
  let removedEdits = [];
  // Check if positionEdits is not empty
  if (positionEdits.current.length > 0) {
    // Find the highest editID in positionEdits
    const maxEditID = Math.max(...positionEdits.current.map((edit) => edit.editID));
    // Remove all elements with the highest editID from positionEdits and push them into undoList
    removedEdits = positionEdits.current.filter((edit) => edit.editID === maxEditID);
    positionEdits.current = positionEdits.current.filter((edit) => edit.editID !== maxEditID);
    undoList.current.push(...removedEdits);
    // // Look up the next highest editID for the removed field names
    lookedUpEdits = removedEdits.map((removedEdit) => {
      const matchingEdits = positionEdits.current.filter((edit) => edit.name === removedEdit.name); // Match the field name
      if (matchingEdits.length === 0) {
        return null; // No matching edits found
      }
      // Find the highest editID among the matching edits
      return matchingEdits.reduce((prev, curr) => (prev.editID > curr.editID ? prev : curr));
    });
    // Update the USposition and USpositionData state with the looked-up edits
    lookedUpEdits.forEach((edit) => {
      if (edit) {
        // console.log(edit);
        if (numtypes.includes(edit.figuretype)) {
          setUSposition((prev) => ({
            ...prev,
            [edit.name]: edit.value,
          }));
          setUSpositionData((prev) => ({
            ...prev,
            [edit.name]: edit.num,
          }));
        } else if (edit.figuretype === "portion" || edit.figuretype === "termdays") {
          setPaymentterm((prev) =>
            prev.map((item) => (item.row === edit.row ? { ...item, [edit.figuretype]: edit.value } : item))
          );
          setPaymenttermData((prev) =>
            prev.map((item) => (item.row === edit.row ? { ...item, [edit.figuretype]: edit.num } : item))
          );
        } else if (edit.figuretype === "payType") {
          setPaymentterm((prev) =>
            prev.map((item) => (item.row === edit.row ? { ...item, [edit.figuretype]: edit.value } : item))
          );
          setPaymenttermData((prev) =>
            prev.map((item) => (item.row === edit.row ? { ...item, [edit.figuretype + "ID"]: edit.num } : item))
          );
          setToggleClearSF((prev) => !prev);
        } else if (edit.figuretype === "delpayrow") {
          let temp5 = edit.temp;
          let temp6 = edit.tempData;
          setPaymentterm((prev) => [...prev.slice(0, edit.ind), temp5, ...prev.slice(edit.ind, prev.length)]);
          setPaymenttermData((prev) => [...prev.slice(0, edit.ind), temp6, ...prev.slice(edit.ind, prev.length)]);
        } else {
          setUSposition((prev) => ({
            ...prev,
            [edit.name]: edit.value,
          }));
          setUSpositionData((prev) => ({
            ...prev,
            [edit.nameID]: edit.valueID,
          }));
        }
      }
    });
    // If input element is part of a calculator module, then setShowcalculator to make the calculator visible
    const outboundvars = ["outdrayage", "loading", "outcollectcharges", "outboundothers", "outpayload"];
    const oceanfrvars = ["oceanpayload", "oceanfreight"];
    const importcustomvars = [
      "generaldutyimp",
      "additionaldutyimp",
      "harborfeepct",
      "merchprocfeepct",
      "flatfee",
      "tsca",
      "isf",
    ];
    const inboundvars = ["inpayload", "indrayage", "unloading", "incollectcharges", "inboundothers"];
    const insurvars = ["insurancerate", "insurancefactor"];
    if (outboundvars.includes(lookedUpEdits[0]?.name)) {
      setShowcalculator("outboundcost");
    } else if (oceanfrvars.includes(lookedUpEdits[0]?.name)) {
      setShowcalculator("oceanfreight");
    } else if (importcustomvars.includes(lookedUpEdits[0]?.name)) {
      setShowcalculator("importcustomsfee");
    } else if (inboundvars.includes(lookedUpEdits[0]?.name)) {
      setShowcalculator("inboundcost");
    } else if (insurvars.includes(lookedUpEdits[0]?.name)) {
      setShowcalculator("insurance");
    } else {
      setShowcalculator("");
    }
    // Focus the input field of the first lookedup edit
    if (numtypes.includes(lookedUpEdits[0]?.figuretype)) {
      setUndoFocusFlag(lookedUpEdits[0]?.name);
    } else if (
      lookedUpEdits[0]?.figuretype === "portion" ||
      lookedUpEdits[0]?.figuretype === "termdays" ||
      removedEdits[0]?.figuretype === "payType"
    ) {
      setUndoFocusFlag(lookedUpEdits[0]?.name);
    } else {
      setUndoFocusFlag(lookedUpEdits[0]?.nameID);
    }
    // If no previous edit found for any of the removed edits, reset to unedited value from initial load state
    if (lookedUpEdits.filter((edit) => edit !== null).length === 0) {
      removedEdits.forEach((re) => {
        if (re) {
          if (numtypes.includes(re.figuretype)) {
            setUSposition((prev) => ({
              ...prev,
              [re.name]: loadedPosition.current ? loadedPosition.current[re.name] : "",
            }));
            setUSpositionData((prev) => ({
              ...prev,
              [re.name]: loadedPositionData.current ? loadedPositionData.current[re.name] : "",
            }));
          } else if (re.figuretype === "portion" || re.figuretype === "termdays") {
            setPaymentterm((prev) =>
              prev.map((item) => {
                if (item.row === re.row) {
                  const match = loadedPayterm.current.find((d) => d.row === re.row);
                  return match ? { ...item, [re.figuretype]: match[re.figuretype] } : item;
                }
                return item;
              })
            );
            setPaymenttermData((prev) =>
              prev.map((item) => {
                if (item.row === re.row) {
                  const match = loadedPaytermData.current.find((d) => d.row === re.row);
                  return match ? { ...item, [re.figuretype]: match[re.figuretype] } : item;
                }
                return item;
              })
            );
          } else if (re.figuretype === "payType") {
            setPaymentterm((prev) =>
              prev.map((item) => {
                if (item.row === re.row) {
                  const match = loadedPayterm.current.find((d) => d.row === re.row);
                  return match ? { ...item, [re.figuretype]: match[re.figuretype] } : item;
                }
                return item;
              })
            );
            setPaymenttermData((prev) =>
              prev.map((item) => {
                if (item.row === re.row) {
                  const match = loadedPaytermData.current.find((d) => d.row === re.row);
                  return match ? { ...item, [re.figuretype + "ID"]: match[re.figuretype + "ID"] } : item;
                }
                return item;
              })
            );
            setToggleClearSF((prev) => !prev);
          } else if (re.figuretype === "delpayrow") {
            setPaymentterm((prev) => [...prev.slice(0, re.ind), re.temp, ...prev.slice(re.ind, prev.length)]);
            setPaymenttermData((prev) => [...prev.slice(0, re.ind), re.tempData, ...prev.slice(re.ind, prev.length)]);
          } else if (re.figuretype === "addpayrow") {
            setPaymentterm((prev) => prev.filter((item) => item.row !== re.row));
            setPaymenttermData((prev) => prev.filter((item) => item.row !== re.row));
          } else {
            setUSposition((prev) => ({
              ...prev,
              [re.name]: loadedPosition.current ? loadedPosition.current[re.name] : "",
            }));
            setUSpositionData((prev) => ({
              ...prev,
              [re.nameID]: loadedPositionData.current ? loadedPositionData.current[re.nameID] : "",
            }));
          }
        }
      });

      if (outboundvars.includes(removedEdits[0]?.name)) {
        setShowcalculator("outboundcost");
      } else if (oceanfrvars.includes(removedEdits[0]?.name)) {
        setShowcalculator("oceanfreight");
      } else if (importcustomvars.includes(removedEdits[0]?.name)) {
        setShowcalculator("importcustomsfee");
      } else if (inboundvars.includes(removedEdits[0]?.name)) {
        setShowcalculator("inboundcost");
      } else if (insurvars.includes(removedEdits[0]?.name)) {
        setShowcalculator("insurance");
      } else {
        setShowcalculator("");
      }
      // Focus the input field of the first removed edit
      if (numtypes.includes(removedEdits[0]?.figuretype)) {
        setUndoFocusFlag(removedEdits[0]?.name);
      } else if (
        removedEdits[0]?.figuretype === "portion" ||
        removedEdits[0]?.figuretype === "termdays" ||
        removedEdits[0]?.figuretype === "payType"
      ) {
        // console.log("name", removedEdits[0]?.name);

        setUndoFocusFlag(removedEdits[0]?.name);
      } else {
        setUndoFocusFlag(removedEdits[0]?.nameID);
      }
    }
  } else {
    setShowcalculator("");
  }
  // Update the editID state
  setEditID((prev) => (prev > 0 ? prev - 1 : 0));
};

export const redoLastEdit = (
  e,
  setToggleClearSF,
  undoList,
  positionEdits,
  setUSposition,
  setUSpositionData,
  setShowcalculator,
  setUndoFocusFlag,
  setEditID,
  setPaymentterm,
  setPaymenttermData,
  loadedPayterm,
  loadedPaytermData
) => {
  e.preventDefault();
  // Get the currently focused input field
  const activeInput = document.activeElement;
  // Check if the focused input field has a value then esc the input and exit.
  if (activeInput && activeInput.value) {
    setToggleClearSF((prev) => !prev);
  }
  // Check if undoList is not empty
  if (undoList.current.length > 0) {
    // Find the lowest editID in undoList
    const minEditID = Math.min(...undoList.current.map((edit) => edit.editID));
    let redoEdits = [];
    // Remove all elements with the lowest EditID from undoList and push them into positionEdits
    redoEdits = undoList.current.filter((edit) => edit.editID === minEditID);
    undoList.current = undoList.current.filter((edit) => edit.editID !== minEditID);
    positionEdits.current.push(...redoEdits);

    const numtypes = ["decimal", "percent", "currency", "integer", "radio", "text"];
    // Set USposition and USpositionData to the values of the redoEdits
    redoEdits.forEach((edit) => {
      if (numtypes.includes(edit.figuretype)) {
        // Update USposition and USpositionData state
        setUSposition((prev) => ({
          ...prev,
          [edit.name]: edit.value,
        }));
        setUSpositionData((prev) => ({
          ...prev,
          [edit.name]: edit.num,
        }));
      } else if (edit.figuretype === "portion" || edit.figuretype === "termdays") {
        setPaymentterm((prev) =>
          prev.map((item) => (item.row === edit.row ? { ...item, [edit.figuretype]: edit.value } : item))
        );
        setPaymenttermData((prev) =>
          prev.map((item) => (item.row === edit.row ? { ...item, [edit.figuretype]: edit.num } : item))
        );
      } else if (edit.figuretype === "payType") {
        setPaymentterm((prev) =>
          prev.map((item) => (item.row === edit.row ? { ...item, [edit.figuretype]: edit.value } : item))
        );
        setPaymenttermData((prev) =>
          prev.map((item) => (item.row === edit.row ? { ...item, [edit.figuretype + "ID"]: edit.num } : item))
        );
        setToggleClearSF((prev) => !prev);
      } else if (edit.figuretype === "delpayrow") {
        setPaymentterm((prev) => prev.filter((item) => item.row !== edit.row));
        setPaymenttermData((prev) => prev.filter((item) => item.row !== edit.row));
      } else if (edit.figuretype === "addpayrow") {
        setPaymentterm((prev) => [
          ...prev,
          { row: edit.row, portion: "0.00%", payType: "CAD", termdays: "10", type: "new" },
        ]);
        setPaymenttermData((prev) => [...prev, { row: edit.row, portion: 0, payTypeID: 1, termdays: 10, type: "new" }]);
      } else {
        // Update USposition and USpositionData state
        setUSposition((prev) => ({
          ...prev,
          [edit.name]: edit.value,
        }));
        setUSpositionData((prev) => ({
          ...prev,
          [edit.nameID]: edit.valueID,
        }));
      }
    });
    const outboundvars = ["outdrayage", "loading", "outcollectcharges", "outboundothers", "outpayload"];
    const oceanfrvars = ["oceanpayload", "oceanfreight"];
    const importcustomvars = [
      "generaldutyimp",
      "additionaldutyimp",
      "harborfeepct",
      "merchprocfeepct",
      "flatfee",
      "tsca",
      "isf",
    ];
    const inboundvars = ["inpayload", "indrayage", "unloading", "incollectcharges", "inboundothers"];
    const insurvars = ["insurancerate", "insurancefactor"];

    if (outboundvars.includes(redoEdits[0]?.name)) {
      setShowcalculator("outboundcost");
    } else if (oceanfrvars.includes(redoEdits[0]?.name)) {
      setShowcalculator("oceanfreight");
    } else if (importcustomvars.includes(redoEdits[0]?.name)) {
      setShowcalculator("importcustomsfee");
    } else if (inboundvars.includes(redoEdits[0]?.name)) {
      setShowcalculator("inboundcost");
    } else if (insurvars.includes(redoEdits[0]?.name)) {
      setShowcalculator("insurance");
    } else {
      setShowcalculator("");
    }
    // Focus the input field of the first removed edit
    if (numtypes.includes(redoEdits[0]?.figuretype)) {
      setUndoFocusFlag(redoEdits[0]?.name);
    } else if (
      redoEdits[0]?.figuretype === "portion" ||
      redoEdits[0]?.figuretype === "termdays" ||
      redoEdits[0]?.figuretype === "payType"
    ) {
      // console.log("name", redoEdits[0]?.name);
      setUndoFocusFlag(redoEdits[0]?.name);
    } else {
      setUndoFocusFlag(redoEdits[0]?.nameID);
    }
  }
  setEditID((prev) => prev + 1);
  // console.log(positionEdits.current);
};
